// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const { withRouter } = require('react-router-dom');

// @ helpers
const { formatText, getFinalTitle } = require('core/i18n').i18n;

// @ commons
const { OKHeaderSubPage } = require('commonsComponents/OKHeaderSubPage');
const { OKCover } = require('commonsComponents/OKCover');
const { LoadingSection } = require('commonsComponents/loadingSection');

// @ components
const MortgageRequestMovingExpenses = require('components/mortgageRequest/mortgageRequestMovingExpenses/mortgageRequestMovingExpenses');
const MortgageRequestMovingExpenseInformation = require('components/mortgageRequest/mortgageRequestMovingExpenses/mortgageRequestMovingExpensesInformation/mortgageRequestMovingExpensesInformation');

// @actions
const mortgateRequestMovingExpensesAction = require('actions/mortgageRequest/mortgageRequestMovingExpenses');

class MortgageRequestMovingExpensesView extends React.Component {
    constructor(props) {
        super(props);

        this.handleCalculateMovingFee = this.handleCalculateMovingFee.bind(this);
        this.handleAcceptMovingFee = this.handleAcceptMovingFee.bind(this);
    }

    handleAcceptMovingFee(expensesValue) {
        this.props.acceptMovingFee(expensesValue, this.props.history);
    }

    handleCalculateMovingFee(expensesValue) {
        this.props.requestMonthlyFee(expensesValue);
    }

    render() {
        const { immMortgageRequestMortgageData, immMortgageRequestMovingExpensesData, immGlobalPosition } = this.props;
        const isClientWithoutAccounts = immGlobalPosition.get("isClientWithoutAccounts");
        const mappingBreadcrumb = [
            {
                text: formatText('navbar-loans'),
                url: '/myprofile/loans-mortgages'
            },
            {
                text: formatText('mortgageRequestPresentation-title'),
                url: '/myprofile/mortgage/panel'
            },
            {
                text: formatText('mortgageRequestMovingExpensesView-mortgageRequestMovingExpensesView_breadcrumb'),
                url: ''
            }
        ].filter((config, index) => (isClientWithoutAccounts && index !== 0) || !isClientWithoutAccounts);

        let content;

        if (!!immMortgageRequestMortgageData && immMortgageRequestMortgageData.get('isFetching')) {
            content = <LoadingSection />;
        } else {
            content = (
                <MortgageRequestMovingExpenses
                    immMortgageRequestMortgageData={immMortgageRequestMortgageData}
                    immMortgageRequestMovingExpensesData={immMortgageRequestMovingExpensesData}
                    onCalculateMovingFee={this.handleCalculateMovingFee}
                    onAcceptMovingFee={this.handleAcceptMovingFee}
                />
            );
        }

        return (
            <div className="mortgage-request-moving-expenses-view" >
                <div className="container-fluid">
                    <div className="row">
                        <OKCover size="medium" section="loansmortgages" customClass="col-xs-12">
                            <OKHeaderSubPage
                                breadcrumbConfig={mappingBreadcrumb}
                                finalTitle={getFinalTitle('mortgageRequestMovingExpensesView-mortgageRequestMovingExpensesView_title')}
                            />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid">
                        <div className="row grid-view--content-position-negative">
                            <div className="col-xs-8">
                                {content}
                            </div>
                            <div className="col-xs-4">
                                <MortgageRequestMovingExpenseInformation />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

MortgageRequestMovingExpensesView.propTypes = {
    requestMonthlyFee: PropTypes.func,
    acceptMovingFee: PropTypes.func,
    immMortgageRequestMortgageData: PropTypes.object,
    immMortgageRequestMovingExpensesData: PropTypes.object,
    immGlobalPosition: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
}

module.exports.MortgageRequestMovingExpensesView = withRouter(connect(
    state => ({
        immMortgageRequestMortgageData: state.mortgageRequestMortgageData,
        immMortgageRequestMovingExpensesData: state.mortgageRequestMovingExpenses,
        immGlobalPosition: state.globalPosition,
    }), {
    requestMonthlyFee: mortgateRequestMovingExpensesAction.requestMonthlyFee,
    acceptMovingFee: mortgateRequestMovingExpensesAction.acceptMovingFee
}
)(MortgageRequestMovingExpensesView));
